import {
  GlobalUserExportRequest,
  ExportPassengerRequest,
  CompanyExportRequest,
  PaymentPartnerExportRequest,
  UtilityPartnerExportRequest,
  SoftwareComponentExportRequest,
  CompanyUserExportRequest,
  BusExportRequest,
  BaggageTariffExportRequest,
  BasicTariffExportRequest,
  TripExportRequest,
  ExportSaleReportRequest,
  SaleWithGroupReportRequest,
  ExportTripDetailReportRequest,
  ExportTripIncomeReportRequest,
  CompanyTripReportRequest,
  CompanyUnEarnedRevenueReportRequest,
  ExportConektoUserRequest,
  TripTravelerPdfReportRequest,
} from '@/__generated';
import { fileService } from './fileService';
import i18n from '@/helpers/i18n';
import httpClient, { apiSdk } from '@/httpClient';
import { message } from 'antd';

class ExportService {
  _handleApiDownloadPromise = (apiPromise: Promise<any>) => {
    const loader = message.loading(i18n.t('Downloading') as any);
    apiPromise
      .then(res => {
        fileService.saveByte2File(fileService.getFileName(res.headers), res.data);
      })
      .catch(() => {
        message.error(i18n.t('Error') as any);
      })
      .finally(() => {
        loader();
      });
  };
  // admin user
  exportGlobalUsers = (body: GlobalUserExportRequest) => ({
    toPdf: () => {
      this._handleApiDownloadPromise(
        httpClient.post(`/user-accounts/global-users/export-pdf`, body, {
          responseType: 'arraybuffer',
        }),
      );
    },
    toExcel: () => {
      this._handleApiDownloadPromise(
        httpClient.post(`/user-accounts/global-users/export-excel`, body, {
          responseType: 'arraybuffer',
        }),
      );
    },
  });

  // passenger
  exportPassengers = (body: ExportPassengerRequest) => ({
    toPdf: () => {
      this._handleApiDownloadPromise(
        httpClient.post(`/bookings/booking-passengers/export-pdf`, body, {
          responseType: 'arraybuffer',
        }),
      );
    },
    toExcel: () => {
      this._handleApiDownloadPromise(
        httpClient.post(`/bookings/booking-passengers/export-excel`, body, {
          responseType: 'arraybuffer',
        }),
      );
    },
  });
  // company
  exportCompanies = (body: CompanyExportRequest) => ({
    toPdf: () => {
      this._handleApiDownloadPromise(
        httpClient.post(`/commons/companies/export-pdf`, body, {
          responseType: 'arraybuffer',
        }),
      );
    },
    toExcel: () => {
      this._handleApiDownloadPromise(
        httpClient.post(`/commons/companies/export-excel`, body, {
          responseType: 'arraybuffer',
        }),
      );
    },
  });
  // company
  exportPaymentPartner = (body: PaymentPartnerExportRequest) => ({
    toPdf: () => {
      this._handleApiDownloadPromise(
        httpClient.post(`/commons/payment-partners/export-pdf`, body, {
          responseType: 'arraybuffer',
        }),
      );
    },
    toExcel: () => {
      this._handleApiDownloadPromise(
        httpClient.post(`/commons/payment-partners/export-excel`, body, {
          responseType: 'arraybuffer',
        }),
      );
    },
  });

  exportUtilityPartner = (body: UtilityPartnerExportRequest) => ({
    toPdf: () => {
      this._handleApiDownloadPromise(
        httpClient.post(`/commons/utility-partners/export-pdf`, body, {
          responseType: 'arraybuffer',
        }),
      );
    },
    toExcel: () => {
      this._handleApiDownloadPromise(
        httpClient.post(`/commons/utility-partners/export-excel`, body, {
          responseType: 'arraybuffer',
        }),
      );
    },
  });
  exportSoftwareComponents = (body: SoftwareComponentExportRequest) => ({
    toPdf: () => {
      this._handleApiDownloadPromise(
        httpClient.post(`/commons/software-components/export-pdf`, body, {
          responseType: 'arraybuffer',
        }),
      );
    },
    toExcel: () => {
      this._handleApiDownloadPromise(
        httpClient.post(`/commons/software-components/export-excel`, body, {
          responseType: 'arraybuffer',
        }),
      );
    },
  });
  exportStaffs = (body: CompanyUserExportRequest) => ({
    toPdf: () => {
      this._handleApiDownloadPromise(
        httpClient.post(`/user-accounts/company-users/export-pdf`, body, {
          responseType: 'arraybuffer',
        }),
      );
    },
    toExcel: () => {
      this._handleApiDownloadPromise(
        httpClient.post(`/user-accounts/company-users/export-excel`, body, {
          responseType: 'arraybuffer',
        }),
      );
    },
  });
  exportBuses = (body: BusExportRequest) => ({
    toPdf: () => {
      this._handleApiDownloadPromise(
        httpClient.post(`/fleets/buses/export-pdf`, body, {
          responseType: 'arraybuffer',
        }),
      );
    },
    toExcel: () => {
      this._handleApiDownloadPromise(
        httpClient.post(`/fleets/buses/export-excel`, body, {
          responseType: 'arraybuffer',
        }),
      );
    },
  });
  exportBaggageTariff = (body: BaggageTariffExportRequest) => ({
    toPdf: () => {
      this._handleApiDownloadPromise(
        httpClient.post(`/fleets/baggage-tariffs/export-pdf`, body, {
          responseType: 'arraybuffer',
        }),
      );
    },
    toExcel: () => {
      this._handleApiDownloadPromise(
        httpClient.post(`/fleets/baggage-tariffs/export-excel`, body, {
          responseType: 'arraybuffer',
        }),
      );
    },
  });
  exportTicketTariff = (body: BasicTariffExportRequest) => ({
    toPdf: () => {
      this._handleApiDownloadPromise(
        httpClient.post(`/fleets/basic-tariffs/export-pdf`, body, {
          responseType: 'arraybuffer',
        }),
      );
    },
    toExcel: () => {
      this._handleApiDownloadPromise(
        httpClient.post(`/fleets/basic-tariffs/export-excel`, body, {
          responseType: 'arraybuffer',
        }),
      );
    },
  });
  exportTrips = (body: TripExportRequest) => ({
    toPdf: () => {
      this._handleApiDownloadPromise(
        httpClient.post(`/fleets/trips/export-pdf`, body, {
          responseType: 'arraybuffer',
        }),
      );
    },
    toExcel: () => {
      this._handleApiDownloadPromise(
        httpClient.post(`/fleets/trips/export-excel`, body, {
          responseType: 'arraybuffer',
        }),
      );
    },
  });
  downloadBookingPdf = (bookingId: string) => {
    this._handleApiDownloadPromise(
      httpClient.post(
        `/bookings/booking-details/download-booking-pdf/${bookingId}`,
        {},
        {
          responseType: 'arraybuffer',
        },
      ),
    );
  };
  // api/company-sale-reports/export-excel
  exportSaleReport = (body: ExportSaleReportRequest) => ({
    toPdf: () => {
      this._handleApiDownloadPromise(
        httpClient.post(`/company-sale-reports/export-pdf`, body, {
          responseType: 'arraybuffer',
        }),
      );
    },
    toExcel: () => {
      this._handleApiDownloadPromise(
        httpClient.post(`/company-sale-reports/export-excel`, body, {
          responseType: 'arraybuffer',
        }),
      );
    },
  });
  exportSaleWithGroupReport = (body: SaleWithGroupReportRequest) => ({
    toPdf: () => {
      this._handleApiDownloadPromise(
        httpClient.post(`/sale-with-group-reports/export-pdf`, body, {
          responseType: 'arraybuffer',
        }),
      );
    },
    toExcel: () => {
      this._handleApiDownloadPromise(
        httpClient.post(`/sale-with-group-reports/export-excel`, body, {
          responseType: 'arraybuffer',
        }),
      );
    },
  });
  exportCompanyTripDetailReport = (body: ExportTripDetailReportRequest) => ({
    toPdf: () => {
      this._handleApiDownloadPromise(
        httpClient.post(`/company-trip-detail-reports/export-pdf`, body, {
          responseType: 'arraybuffer',
        }),
      );
    },
    toExcel: () => {
      this._handleApiDownloadPromise(
        httpClient.post(`/company-trip-detail-reports/export-excel`, body, {
          responseType: 'arraybuffer',
        }),
      );
    },
  });
  exportTripIncomeReport = (body: ExportTripIncomeReportRequest) => ({
    toPdf: () => {
      this._handleApiDownloadPromise(
        httpClient.post(`/company-trip-income-reports/export-pdf`, body, {
          responseType: 'arraybuffer',
        }),
      );
    },
    toExcel: () => {
      this._handleApiDownloadPromise(
        httpClient.post(`/company-trip-income-reports/export-excel`, body, {
          responseType: 'arraybuffer',
        }),
      );
    },
  });
  exportTripReport = (body: CompanyTripReportRequest) => ({
    toPdf: () => {
      this._handleApiDownloadPromise(
        httpClient.post(`/company-trip-reports/export-pdf`, body, {
          responseType: 'arraybuffer',
        }),
      );
    },
    toExcel: () => {
      this._handleApiDownloadPromise(
        httpClient.post(`/company-trip-reports/export-excel`, body, {
          responseType: 'arraybuffer',
        }),
      );
    },
  });
  exportUnearnedReport = (body: CompanyUnEarnedRevenueReportRequest) => ({
    toPdf: () => {
      this._handleApiDownloadPromise(
        httpClient.post(`/unearned-reports/export-pdf`, body, {
          responseType: 'arraybuffer',
        }),
      );
    },
    toExcel: () => {
      this._handleApiDownloadPromise(
        httpClient.post(`/unearned-reports/export-excel`, body, {
          responseType: 'arraybuffer',
        }),
      );
    },
  });

  exportPassengerAppUsers = (body: ExportConektoUserRequest) => ({
    toPdf: () => {
      this._handleApiDownloadPromise(
        httpClient.post(`/liane-users/export-pdf`, body, {
          responseType: 'arraybuffer',
        }),
      );
    },
  });
  exportTripPassenger = (body: TripTravelerPdfReportRequest) => ({
    toPdf: () => {
      this._handleApiDownloadPromise(
        httpClient.post(`/fleets/trip-details/export-traveler-report-pdf`, body, {
          responseType: 'arraybuffer',
        }),
      );
    },
  });
  exportBoxCategory = (body: any) => ({
    toPdf: () => {
      this._handleApiDownloadPromise(
        httpClient.post(`/shipments/box-categories/export-pdf`, body, {
          responseType: 'arraybuffer',
        }),
      );
    },
    toExcel: () => {
      this._handleApiDownloadPromise(
        httpClient.post(`/shipments/box-categories/export-excel`, body, {
          responseType: 'arraybuffer',
        }),
      );
    },
  });
  exportBoxType = (body: any) => ({
    toPdf: () => {
      this._handleApiDownloadPromise(
        httpClient.post(`/shipments/box-types/export-pdf`, body, {
          responseType: 'arraybuffer',
        }),
      );
    },
    toExcel: () => {
      this._handleApiDownloadPromise(
        httpClient.post(`/shipments/box-types/export-excel`, body, {
          responseType: 'arraybuffer',
        }),
      );
    },
  });
  exportBoxVolume = (body: any) => ({
    toPdf: () => {
      this._handleApiDownloadPromise(
        httpClient.post(`/shipments/box-volumes/export-pdf`, body, {
          responseType: 'arraybuffer',
        }),
      );
    },
    toExcel: () => {
      this._handleApiDownloadPromise(
        httpClient.post(`/shipments/box-volumes/export-excel`, body, {
          responseType: 'arraybuffer',
        }),
      );
    },
  });
  exportBoxWeight = (body: any) => ({
    toPdf: () => {
      this._handleApiDownloadPromise(
        httpClient.post(`/shipments/box-weights/export-pdf`, body, {
          responseType: 'arraybuffer',
        }),
      );
    },
    toExcel: () => {
      this._handleApiDownloadPromise(
        httpClient.post(`/shipments/box-weights/export-excel`, body, {
          responseType: 'arraybuffer',
        }),
      );
    },
  });
}

export const exportService = new ExportService();
